import Axios, { AxiosRequestConfig } from 'axios';
import {
  URL_BACKEND_ROOT
} from "../app/AppConst";
import AuthUtility from "../util/AuthUtility";
import { BaseResponse } from '../dto/response/BaseResponse';
import { ReadResponse } from '../dto/response/ReadResponse';
import { BannerModel } from '../dto/banner/BannerModel';
import { BannerEntity } from '../dto/banner/BannerEntity';
import { FileModel } from '../dto/FileModel';
import { FileEntity } from '../dto/file/FileEntity';
import { BannerSearch } from '../dto/banner/BannerSearch';
import { ApiClient } from '../util/ApiUtility';
import { BrandEntity } from '../dto/brand/BrandEntity';

export const onBannerSubmit = async (banner: BannerModel, file: FileModel) => {
    const requestConfig: AxiosRequestConfig = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'PUT',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/banner',
      data: banner
    }

    var bannerId = undefined;
    var bannerResponse = await ApiClient().request<BaseResponse<BannerEntity>>(requestConfig);
    if (bannerResponse.status >= 200 && bannerResponse.status < 300) {
      var bannerBaseResponse = bannerResponse.data;
      var bannerData = bannerBaseResponse.data;
      bannerId = bannerData.id;
      if (file.data === undefined) {
        return bannerResponse.data; 
      }
    } else {
        throw new Error("Амжилтгүй");
    }

    var bannerPhoto = undefined;
    if (bannerId !== undefined) {
      requestConfig.url = `${URL_BACKEND_ROOT}` + '/v1/cms/file/upload';
      requestConfig.method = 'POST';
      requestConfig.headers = {
        'Content-Type': 'multipart/form-data',
      }
      requestConfig.data = file;
      var fileResponse = await ApiClient().request<BaseResponse<FileEntity>>(requestConfig);
      if (fileResponse.status >= 200 && fileResponse.status < 300) {
        var fileBaseResponse = fileResponse.data;
        var fileData = fileBaseResponse.data;
        bannerPhoto = fileData.originalName;
      } else {
        throw new Error("Файл хадгалах үед алдаа гарлаа");
      }
    }

    if (bannerPhoto !== undefined) {
      banner = {
        action: "update",
        entity: {
          id: bannerId,
          photo: bannerPhoto
        }
      };
      requestConfig.url = `${URL_BACKEND_ROOT}` + '/v1/cms/banner';
      requestConfig.method = 'PUT';
      requestConfig.headers = {
        'Content-Type': 'application/json'
      }
      requestConfig.data = banner;
      bannerResponse = await ApiClient().request<BaseResponse<BannerEntity>>(requestConfig);
      if (bannerResponse.status >= 200 && bannerResponse.status < 300) {
        return bannerResponse.data;
      } else {
        throw new Error("Файлын зураг оноох үед алдаа гарлаа");
      }
    }
}

export const onBannerSearch = async (data: BannerSearch) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/banner',
    params: {
      ids: data.ids,
      offset: data.offset,
      limit: data.limit
    }
  }
  const response = await ApiClient().request<ReadResponse>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}